import HoldingCompanySettings from './HoldingCompanySettings';

export default HoldingCompanySettings;
